<template>
  <input type="text" />
</template>

<script>
/* global API_URL */
import { mapState } from 'vuex'
import $ from 'jquery'
import 'jquery-tokeninput'
require('jquery-tokeninput/styles/token-input-facebook.css')

export default {
  name: 'channel-selector',
  props: ['name', 'value'],
  data () {
    return {
      items: []
    }
  },
  computed: {
    ...mapState(['user'])
  },
  mounted () {
    this.idsInTokens = []
    $(this.$el).tokenInput(
      API_URL + '/channels/search?token=' + encodeURIComponent(this.user.token),
      {
        searchingText: 'Keresés...',
        noResultsText: 'Nincs találat',
        hintText: 'Adj meg egy szöveget',
        theme: 'facebook',
        preventDuplicates: true,
        onAdd: (item) => {
          this.addItem(item)
        },
        onDelete: (item) => {
          this.deleteItem(item)
        }
      }
    )
  },
  watch: {
    value (items) {
      this.setTokens(items)
    }
  },
  methods: {
    addItem (item) {
      this._registerItemId(item.id)
      this.items.push(this._extractItemFields(item))
      this.updateValue()
    },
    _extractItemFields (item) {
      return {
        id: item.id,
        name: item.name,
        appKey: item.appKey,
        picture: item.picture
      }
    },
    _registerItemId (itemId) {
      this.idsInTokens.push(itemId)
    },
    deleteItem (item) {
      var idx = this.items.findIndex((e) => e.id === item.id)
      this._unregisterItemId(item.id)
      if (idx !== -1) {
        this.items.splice(idx, 1)
        this.updateValue()
      }
    },
    _unregisterItemId (itemId) {
      var idx = this.idsInTokens.indexOf(itemId)
      if (idx !== -1) {
        this.idsInTokens.splice(idx, 1)
      }
    },
    updateValue () {
      this.$emit('input', this.items)
    },
    setTokens (items) {
      items.forEach((item) => {
        if (!this._isRegisteredItemId(item.id)) {
          this._registerItemId(item.id)
          $(this.$el).tokenInput('add', this._extractItemFields(item))
        }
      })
    },
    _isRegisteredItemId (itemId) {
      return this.idsInTokens.indexOf(itemId) !== -1
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  @import '../../sass/foundation-import';
  @import '../../sass/inputs/tokeninput';
</style>



// WEBPACK FOOTER //
// channel-selector.vue?4e4679fb